import { trackPromise } from "react-promise-tracker";
import useProviders from "../../providers";

const useNavBarServices = () => {
  const { useNavBarProvider } = useProviders();
  const {
    getNavBarItemsProvider
  } = useNavBarProvider();

  const getNavBarItemsService = (permissions, role) => {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await trackPromise(getNavBarItemsProvider(permissions, role)));
      } catch (error) {
        reject(error);
      }
    });
  };

  return {
    getNavBarItemsService
  };
};
export default useNavBarServices;
